export default "__VITE_ASSET__CHBaMQtT__"